import Modal from "../../layouts/Modal";
import LoadingWheel from "../shared/LoadingWheel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { IPart } from "../../models/Part";
import useWarehouseLocations from "../../data/useWarehouseLocations";
import { TextInput } from "../shared/Inputs/TextInput";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import usePartMutations from "../../data/usePartMutations";
import WarehouseLocationCapacity from "../warehouseLocations/WarehouseLocationCapacity";

interface PromotionPickerProps {
  open: boolean;
  setOpen: any;
  part: IPart | undefined;
}

export default function LocationPicker({ open, setOpen, part }: PromotionPickerProps) {
  const { t } = useTranslation("stock");
  const { warehouseLocations } = useWarehouseLocations();
  const { patchPart } = usePartMutations();

  // const promotionClicked = (promo: IPromotion) =>{
  //   applyPromotion.mutate({part: part, promo: promo}, {
  //     onSuccess: ()=>{
  //       setOpen(false);
  //     }
  //   })
  // }

  const setLocation = (locationId: string) => {
    patchPart.mutate({ ...part, warehouseLocationId: locationId }, {
      onSuccess: () => {
        setOpen(false);
      }
    })
  };

  const { watch, register } = useForm({
    defaultValues: {
      search: ""
    }
  });

  return <Modal open={open} setOpen={setOpen} width={"max-w-2xl"}>
    {
      warehouseLocations.isLoading || (warehouseLocations as any).data.data == null ?
        <LoadingWheel /> :
        <div>
          <h1 className="text-xl font-bold">{t("Change Warehouse Locations")}</h1>
          <TextInput label={t("Search")} register={register} registerName={"search"} />
          <div className="max-h-[50vh] overflow-y-scroll mt-2 p-2 space-y-1">
            {
              (warehouseLocations as any).data.data.filter((x: any) => x.displayName?.toLowerCase().includes(watch("search")?.toLowerCase())).map((x: any, i: number) =>
                <div
                  className={`flex flex-row cursor-pointer transition-transform hover:translate-x-2 hover:font-bold ${part?.warehouseLocationId != x.id ? "" : "translate-x-2 font-bold"}`}
                  key={i} onClick={() => setLocation(x.id)}
                >
                  {
                    part?.warehouseLocationId != x.id ?
                      <FontAwesomeIcon className="rounded-full p-1 "
                        icon={faSquare}

                      />
                      :
                      <FontAwesomeIcon className="rounded-full p-1"
                        icon={faSquareCheck}
                      />
                  }

                  <p className="pr-2">{x.displayName}</p>
                  <WarehouseLocationCapacity location={x} />
                </div>)
            }
          </div>
        </div>
    }
  </Modal>
}